import DraftsList from './DraftsList';

export default {
  list: DraftsList,
};
